export const ColumnIds = {
  name: 'name',
  specialtyCategoryName: 'specialtyCategoryName',
  displayOrder: 'displayOrder'
} as const;